/**
 * Generates a slug from a string by converting to lowercase, 
 * removing special characters, and replacing spaces with hyphens
 * @param {string} text - Text to convert to slug
 * @returns {string} - The slug
 */
export const generateSlug = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

/**
 * Generates a SEO-friendly URL for a hotel
 * @param {Object} hotel - The hotel object
 * @returns {string} - The SEO-friendly URL
 */
export const generateHotelUrl = (hotel) => {
  if (!hotel || !hotel._id) return '#';
  
  const stateSlug = generateSlug(hotel.location);
  const citySlug = generateSlug(hotel.city);
  const nameSlug = generateSlug(hotel.name);
  
  return `/hotel/${stateSlug}/${citySlug}/${nameSlug}/${hotel._id}`;
};